import React from "react";
import ReactTooltip from "react-tooltip";

export default function Tooltip(props) {
  return (
    <ReactTooltip
      id={props.id}
      effect="solid"
      offset={props.offset_top ? { top: props.offset_top } : {}}
      multiline={true}
      delayShow={300}
      clickable={true}
      className="tooltip"
    />
  );
}
